import * as bootstrap from 'bootstrap';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import selectize from '@selectize/selectize';
import * as moment from 'moment';

(function ($, Drupal) {
  if (drupalSettings.sc.ops_notice) {
    Drupal.behaviors.modalAlert = {
      attach: function(context, settings) {
        var opsModalElem = document.getElementById('ops-notice');

        if (opsModalElem) {
          var opsNotice = bootstrap.Modal.getOrCreateInstance(opsModalElem)

          opsNotice.show();

          opsModalElem.addEventListener('hide.bs.modal', event => {
            var d = new Date();

            d.setTime(d.getTime() + 31557600000);

            document.cookie = "ops_notice=" + drupalSettings.sc.ops_notice + "; expires=" + d.toUTCString() + "; path=/; secure; samesite=strict";
            opsModalElem.remove();
          });
        }
      }
    };
  }
}(jQuery, Drupal));

(function ($, Drupal) {
  Drupal.behaviors.spidercoachPopovers = {
    attach: function(context) {
      $('[data-toggle="popover"]').each(function() {
        const popover = bootstrap.Popover.getOrCreateInstance(this) // Returns a Bootstrap popover instance

        // setContent example
        popover.setContent({
          // '.popover-header': 'another title',
          '.popover-body': $(this).attr('data-content')
        })
      })
    }
  };
}(jQuery, Drupal));

(function ($, Drupal) {
  Drupal.behaviors.spidercoachTimePicker = {
    attach: function(context) {
      $(document).ready(function() {
        $('body').on('change', 'select.time-type', changeTimeType);
        $('body').on('change', 'select.time-part', changeTimePart);

        $('select.time-part').trigger('change');
      });

      function changeTimeType() {
        var ctrl = $(this);

        changeTimeSummary(ctrl.attr('data-for'));
      }

      function changeTimePart() {
        var ctrl = $(this);
        var dirn = ctrl.attr('data-for');
        var real = $('#' + dirn + '-real');
        var curr = real.val().split(':');

        curr[ctrl.hasClass('time-hours') ? 0 : 1] = ctrl.val();

        real.val(curr.join(':'));

        changeTimeSummary(dirn);
      }

      function changeTimeSummary(dirn) {
        if (!$('#' + dirn + '-summary').prop('disabled')) {
          $('#' + dirn + '-summary .display-text').text(($('#' + dirn + '-type').val() == 'after' ? 'Dep ' : 'Arr ') + $('#' + dirn + '-real').val());
        }
      }
    }
  };
}(jQuery, Drupal));

(function ($, Drupal) {
  Drupal.behaviors.spidercoachDatePicker = {
    attach: function(context) {
      $(once('spidercoachDatePicker', '.datepicker-here', context)).each(function() {
        $(this).parent().addClass('position-relative').append($('<div class="datepicker-value bg-white position-absolute top-50 start-0 w-100 h-100 translate-middle-y form-control"></div>'));

        var $display = $(this).siblings('.datepicker-value');

        if ($(this).val() && !$(this).attr('disabled')) {
          $display.text(moment.utc($(this).val(), "YYYY-MM-DD").format("DD/MM/YYYY").replace(' 00:00', ''));
          $(this).attr('placeholder', moment.utc($(this).val()).format('DD/MM/YYYY'));
        } else {
          $display.text($(this).attr('placeholder'));
        }

        $(this).find('.datepicker-value').on('click', function() {
          $(this).previous('input').trigger('focus');
        });

        // Set min and max dates using values from attributes [data-date-min] and [data-date-max].
        // Library has handling for min max using attributes [data-min-date] and [data-max-date]
        // but doesn't work as expected so handle manually.
        var elem = $(this);

        $(this).each(function () {
          var datePicker = new AirDatepicker(this, {
            locale: localeEn,
            timepicker: false,
            onlyTimepicker: false,
            dateTimeSeparator: ' ',
            timeFormat: '',
            minHours: 0,
            maxHours: 0,
            minMinutes: 0,
            maxMinutes: 0,
            hoursStep: 1,
            minutesStep: 1,
            showEvent: 'click',
            autoClose: true, // Handle close manually as triggering change reopens datepicker immediately.
            minDate: new Date($(this).attr('data-date-min') * 1000),
            maxDate: new Date($(this).attr('data-date-max') * 1000),
            dateFormat: 'yyyy-MM-dd',
            onShow: () => {
              // $('body').on('click', function(e) {
              //   console.log('here', e);
              //
              //   if (jQuery.contains(element, e.target))
              // });
            },
            onRenderCell: ({date, cellType}) => {
              // Exclude dates from attribute [data-exclude] which is a string of timestamps separated with spaces.
              if ($(this).get(0).hasOwnProperty('exclude')) {
                if (cellType == 'day' && this.exclude) {
                  var exclude = this.exclude.toString().split(' ').map(function (d) {
                    return parseInt(d, 10) * 1000;
                  });

                  var cellDate = new Date(date.setHours(0, 0, 0, 0));

                  if (exclude.indexOf(cellDate.getTime()) > -1) {
                    return {
                      classes: 'my-class',
                      disabled: true
                    }
                  }
                }
              }
            },
            onSelect: ({date, formattedDate, inst}) => {
              $(this).trigger('change');

              // Manually trigger change event as library doesn't do it.
              // if (datePicker.visible) {
              //   $(datePicker.$el).blur();
              // }
            }
          });

          if ($(this).val() && !$(this).attr('disabled')) {
            var tmp = $(this).val().split('-');

            datePicker.selectDate(new Date(tmp[0], tmp[1] - 1, tmp[2]));
          }

          $(this).on('change', function () {
            var $display = $(this).siblings('.datepicker-value');
            $(this).attr('placeholder', moment.utc($(this).val()).format('DD/MM/YYYY'));

            if ($(this).val() && !$(this).attr('disabled')) {
              $display.text(moment.utc($(this).val(), "YYYY-MM-DD").format("DD/MM/YYYY").replace(' 00:00', ''));
              $(this).attr('placeholder', moment.utc($(this).val()).format('DD/MM/YYYY'));
            } else {
              $display.text($(this).attr('placeholder'));
            }
          });

          if (!$(this).attr('disabled')) {
            $(this).parent().on('click', '.datepicker-value', function () {
              datePicker.show();
            });
          }
        });
      });
    }
  };
}(jQuery, Drupal));

(function ($, Drupal) {
  // Show status messages modal on document load.
  Drupal.behaviors.modalStatusMessages = {
    attach: function(context, settings) {
      $(once('modalStatusMessages', '.modal-status-messages', context)).each(function() {
        const myModal = new bootstrap.Modal(this, {
          keyboard: false
        })
        myModal.show()
      });
    }
  }
}(jQuery, Drupal));

(function ($, Drupal) {
  Drupal.behaviors.spidercoachNumberIncrementDecrement = {
    attach: function(context) {

      $(once('spidercoachNumberIncrementDecrement', '.number-increment-decrement', context)).each(function() {
        // Add class to inputs parent element.

        $(this).parent().addClass('number-increment-decrement-wrapper');

        // Add buttons after input.

        var buttonContainer = $('<div class="number-increment-decrement-buttons d-flex flex-row align-items-center"></div>');

        $(this).wrapAll(buttonContainer);

        $(this).before($('<div role="button" class="btn btn-link p-0 me-1"></div>')
          .addClass('number-increment-decrement-button')
          .attr('data-number-action', '-')
          .attr('aria-role', 'button')
          .attr('tabindex', 0)
          .html('<i class="fa-solid fa-circle-minus fa-xl"></i>'));

        $(this).after($('<div role="button" class="btn btn-link p-0 ms-1"></div>')
          .addClass('number-increment-decrement-button')
          .attr('data-number-action', '+')
          .attr('aria-role', 'button')
          .attr('tabindex', 0)
          .html('<i class="fa-solid fa-circle-plus fa-xl"></i>'));

        // Attach click event handler to buttons.

        $(this).parent().on('click', '.number-increment-decrement-button', function(e) {
          e.stopPropagation();

          var $input = $(this).siblings('input')[0];

          var val = parseInt($($input).val());
          var step = parseInt($input.step);
          var min = parseInt($($input).attr('data-min')) || 0;
          var max = parseInt($($input).attr('data-max')) || 0;

          // Respect min/max and step attribute values.

          switch ($(this).attr('data-number-action')) {
            case '+':
              if (max > 0) {
                if (val < max) {
                  val = val + step;
                }
              } else {
                val = val + step;
              }
              break;

            default:
              if (min) {
                if (val > min) {
                  val = val - step;
                }
              } else {
                if (val > 0) {
                  val = val - step;
                }
              }
          }

          // Set value and trigger change.

          $($input).val(val).trigger('change');
        });


        // Attach change event handler to imput.

        $(this).on('change', function(e) {
          var $input = $(this);
          var target = $(this).attr('data-total-target');
          var str = [];

          // If [data-total-target] attribute then add summary to target element.

          if (target) {
            $('input[type="number"][data-total-target="' + target + '"]').each(function() {
              var val = parseInt($(this).val(), 10);

              if (val > 0) {
                str.push(val + ' ' + ((val > 1) ? $(this).attr('data-label-plural') : $(this).attr('data-label-singular')));
              }
            });

            switch (str.length) {
              case 0:    $(target).text($(target).attr('data-placeholder'));    break;
              case 1:    $(target).text(str.pop());                break;
              case 2:    $(target).text(str.join(' and '));            break;
              default:
                var last = str.pop();

                $(target).text(str.join(', ') + ', and ' + last);
                break;
            }
          }
        }).trigger('change');
      });

    }
  };

}(jQuery, Drupal));

(function ($, Drupal) {
  Drupal.behaviors.spidercoachCollapseInDropdown = {
    attach: function(context) {
      $('button[data-bs-toggle="collapse"]').on('click', function(e) {
        var dropdown = $(this).closest('dropdown-menu');

        if (dropdown) {
          e.stopPropagation();
        }
      });
    }
  };
}(jQuery, Drupal));
